import { css } from "styled-components";
// break widths
import { breakWidth480, breakWidth600, breakWidth840, breakWidth960, breakWidth1280, breakWidth1440, breakWidth1600 } from "@churchofjesuschrist/eden-style-constants";

// Mobile first breakpoints
export const mediaBreak480w = function () {
  return css(["@media (min-width:", "){", ";}"], breakWidth480, css(...arguments));
};
export const mediaBreak600w = function () {
  return css(["@media (min-width:", "){", ";}"], breakWidth600, css(...arguments));
};
export const mediaBreak840w = function () {
  return css(["@media (min-width:", "){", ";}"], breakWidth840, css(...arguments));
};
export const mediaBreak960w = function () {
  return css(["@media (min-width:", "){", ";}"], breakWidth960, css(...arguments));
};
export const mediaBreak1280w = function () {
  return css(["@media (min-width:", "){", ";}"], breakWidth1280, css(...arguments));
};
export const mediaBreak1440w = function () {
  return css(["@media (min-width:", "){", ";}"], breakWidth1440, css(...arguments));
};
export const mediaBreak1600w = function () {
  return css(["@media (min-width:", "){", ";}"], breakWidth1600, css(...arguments));
};
export const mediaBreakGutter = function () {
  return css(["@media (min-width:", ") and (min-height:", "){", ";}"], breakWidth600, breakWidth600, css(...arguments));
};

/* BiDi Helpers */
export const dir = theDir => function () {
  return css(["[dir=\"", "\"] &,&[dir=\"", "\"]{", ";}"], theDir, theDir, css(...arguments));
};